export function uploadClaimFields(primarySignedUpload, thumbnailSignedUpload = null) {
  const fields = {};

  if (typeof primarySignedUpload?.upload_claim === "string" && primarySignedUpload.upload_claim) {
    fields.upload_claim = primarySignedUpload.upload_claim;
  }

  if (typeof thumbnailSignedUpload?.upload_claim === "string" && thumbnailSignedUpload.upload_claim) {
    fields.thumbnail_upload_claim = thumbnailSignedUpload.upload_claim;
  }

  return fields;
}

export function signedUploadStorageKey(signedUpload) {
  const key = typeof signedUpload?.key === "string" ? signedUpload.key : "";

  if (!key) {
    throw new Error("Signed upload response is missing its storage key.");
  }

  return key;
}

export function requireWorkspaceUploadId(workspaceId) {
  const normalizedWorkspaceId = typeof workspaceId === "string" ? workspaceId.trim() : "";

  if (!normalizedWorkspaceId) {
    throw new Error("No workspace selected. Please select a workspace before uploading.");
  }

  return normalizedWorkspaceId;
}
